import axios from 'axios';
import Cookies from 'js-cookie';

export const getProductData = () => {
	return JSON.parse(
		document.getElementById('product-data') &&
			document.getElementById('product-data').innerHTML
	);
};

export const getPubCatProdId = () => {
	let docData = getProductData();
	return docData && docData.publishedProductId !== undefined
		? docData.publishedProductId
		: ''; /*Need to replace this from windows scoped javscript variable (product-data) */
};

export const getPubCatId = () => {
	let docData = getProductData();
	return docData && docData.publishedCatalogId
		? docData.publishedCatalogId
		: ''; /*Need to replace this from windows scoped javscript variable (product-data) */
};

export const getAffiliatedId = () => {
	if (Cookies.get('affiliateIds') === undefined) {
		Cookies.set('affiliateIds', '1072075%7C23456%7C9098889', { expires: 7 });
	}
	return Cookies.get('affiliateIds');
};

export const getCustomerNumber = () => {
	let affiliatedId = getAffiliatedId();
	let custNum =
		decodeURI(affiliatedId).split('|')[0] !== ""
			? decodeURI(affiliatedId).split('|')[0]
			: decodeURI(affiliatedId).split('|')[1];
	return custNum;
};

export const getProfileGuid = () => {
	return new Promise((resolve, reject) => {
		axios({
			method: 'get',
			url: '/apps/profile/me.mvc',
		}).then(
			(response) => {
				if (response.status === 200) {
					resolve(response.data.profileGuid);
				} else {
					reject(response);
				}
			},
			(error) => {
				reject(error);
			}
		);
	});
};

// Form validation - email ,firstname , lastname
export const validateEmail = (value, dynamicData) => {
	let errors = {};
	if (value === '') {
		errors.email = dynamicData && dynamicData.requiredEmail;
	} else if (!/\S+@\S+\.\S+/.test(value)) {
		errors.email = dynamicData && dynamicData.invalidEmail;
	}
	return errors;
};
export const validateFirstName = (value,dynamicData) => {
	let fnameerrors = {};
	if (value === '') {
		fnameerrors.firstname = dynamicData && dynamicData.requiredFirstName;
	} else if (value.length > 50) {
		fnameerrors.firstname = dynamicData && dynamicData.charLengthFn;
	}
	return fnameerrors;
};
export const validateLastName = (value,dynamicData) => {
	 let lnameerrors = {};	
		if (value === '') {
			lnameerrors.lastname = dynamicData && dynamicData.requiredLastName;
		} else if (value.length > 50) {
			lnameerrors.lastname = dynamicData && dynamicData.charLengthLn;
		}
	return  lnameerrors;
};
export const emailValidatation = (e, setErrors, dynamicData) => {
	Object.keys(validateEmail(e.target.value)).length
		? e.currentTarget.setAttribute('style', 'border:1px solid red')
		: e.currentTarget.removeAttribute('style');
	setErrors(validateEmail(e.target.value, dynamicData));
};
export const firstNameValidatation = (e, setFirstNameErrors, dynamicData) => {
	Object.keys(validateFirstName(e.target.value)).length
		? e.currentTarget.setAttribute('style', 'border:1px solid red')
		: e.currentTarget.removeAttribute('style');
	setFirstNameErrors(validateFirstName(e.target.value, dynamicData));
};
export const lastNameValidatation = (e, setLastNameErrors,dynamicData) => {
	Object.keys(validateLastName(e.target.value)).length
		? e.currentTarget.setAttribute('style', 'border:1px solid red')
		: e.currentTarget.removeAttribute('style');
	setLastNameErrors(validateLastName(e.target.value, dynamicData));
};

export const getOwnerId = () => {
	let ownerId = Cookies.get('ownerId');
	ownerId = ownerId !== undefined ? ownerId : 'guest';
	return ownerId;
};

export const getAffiliateState = () => Cookies.get('affiliateState');

export const getStoleType = () => {
	return sessionStorage.getItem('stoleType');
};

export const updateSampleData = (profileGuid, selectedTemplate) => {
	let data = {};
	data.customerNumber = getCustomerNumber();
	data.profileGuid = profileGuid;
	data.ownerId = getOwnerId();
	data.variant = getStoleType();
	data.payload = { ...selectedTemplate };
	return data;
};

export const addToCart = async (
	selectedTemplate,
	setSnackBar,
	profileGuid,
	designGuid,
	orderItemID,
	productId,
	selectedStage,
	setLoading,
	StoleMeta
) => {
	setLoading(true);
	let jsonData = updateSampleData(profileGuid, selectedTemplate);
	jsonData.productId = productId;
	jsonData.orderItemID = orderItemID;
	jsonData.designGuid = designGuid;


	let host = process.env.REACT_APP_JOSTENS_STOLE_BUILDER_HOST;

	jsonData.payload.pubCatId = getPubCatId();
	jsonData.payload.pubCatProdId = getPubCatProdId();
	jsonData.payload.designGuid = designGuid;
	jsonData.payload.customerNumber = getCustomerNumber();
	jsonData.payload.designSettings.data.currentStage = selectedStage;
	axios
		.post(`${host}/consumerDesign`, jsonData, {
			headers: {
				'domainName': window.location.hostname,
			},
			withCredentials: true
		})
		.then((res) => {
			setLoading(false);
			let cookies = res.data && res.data.sbCookies;
			(cookies && cookies.length) && cookies.forEach((item)=>{
				Cookies.set(item.name, item.value, {secure: "yes",hostonly:"yes", path:"/", sameSite: "None" });
			})
			window.location.href = '/apps/checkout/startCheckout.mvc';
		})
		.catch((err) => {
			console.log('err->', err);
			setLoading(false);
			setSnackBar({
				open: true,
				variant: 'danger',
				Body: StoleMeta.fail.because,
				Heading: StoleMeta.fail.addToCart,
			});
		});
};

export const getAffiliatedName = () => {
	if (Cookies.get('affiliateName') === undefined) {
		Cookies.set('affiliateName', 'University+of+Northern+Iowa%7CCedar+Falls%7CIA', { expires: 7 });
	}
	return Cookies.get('affiliateName');
};

export const getSchoolName = () => {
	let affiliateName = '';
	let schoolName=''
	affiliateName= getAffiliatedName();
	schoolName = decodeURI(affiliateName);
	schoolName = schoolName && schoolName.replace(/\+/g, ' ');
	schoolName = schoolName && schoolName.split('|')[0];
	return schoolName;
};

export const getSchoolLocation = () => {
	let affiliateName = '';
	let firstSplit = '';
	affiliateName = getAffiliatedName();
	firstSplit = decodeURI(affiliateName);
	firstSplit = firstSplit.replace(/\+/g, ' ');
	let location = firstSplit.split('|')[1] + ', ' + firstSplit.split('|')[2];
	return location;
};

export const sortBasedOnName = (list, name) => {
	list &&
		list.sort((a, b) => {
			let textA = a[name] && a[name].toUpperCase() || '';
			let textB = b[name] && b[name].toUpperCase() || '';
			return textA < textB ? -1 : textA > textB ? 1 : 0;
		});
	return list || [];
};